<template>
    <div class="card col-md-12 mx-auto">
        <div class="card-header card-header h5 m-0">
            {{$t('externalSupplier.tariff')}}
        </div>

        <div class="card-body">
            <div class="row" v-cloak>
                <div class="form-group col-lg-4 col-sm-12">
                    <label class="font-weight-bold required" :for="'name' + _uid">{{ $t('registers.nomenclatures.gridHeaders.name') }}</label>
                    <input type="text" readonly class="form-control-plaintext"
                           :name="'name' + _uid"
                           :id="'name' + _uid"
                           :value="isEnVersion ? model.nameEn : model.name">
                </div>

                <div class="form-group col-lg-4 col-sm-12">
                    <label class="font-weight-bold" :for="'description' + _uid">{{ $t('registers.nomenclatures.gridHeaders.description') }}</label>
                    <input type="text" readonly class="form-control-plaintext"
                           :name="'description' + _uid"
                           :id="'description' + _uid"
                           :value="model.description">
                </div>

                <div class="form-group col-lg-4 col-sm-12" v-if="showContractInfo">
                    <label class="font-weight-bold" :for="'contract' + _uid">{{ $t('contract.cardTitle') }}</label>
                    <input type="text" readonly class="form-control-plaintext"
                           :name="'contract' + _uid"
                           :id="'contract' + _uid"
                           :value="model.contractDisplayName">
                </div>

                <div class="form-group col-lg-4 col-sm-12" v-if="model.allowedEventForms && Array.isArray(model.allowedEventForms)">
                    <label class="font-weight-bold" :for="'contract' + _uid">{{ $t('registers.events.eventForms') }}</label>
                    <div v-if="isEnVersion">
                        <span v-for="form in model.allowedEventFormsEn" class="badge badge-light">{{form}}</span>
                    </div>
                    <div v-else>
                        <span v-for="form in model.defaultForEventForms" class="badge badge-light">{{form}}</span>
                    </div>
                </div>

                <div class="form-group col-lg-4 col-sm-12" v-if="model.defaultForEventForms && Array.isArray(model.defaultForEventForms)">
                    <label class="font-weight-bold" :for="'contract' + _uid">Да се използва по подразбиране при</label>
                    <div v-if="isEnVersion">
                        <span v-for="form in model.defaultForEventFormsEn" class="badge badge-light">{{form}}</span>
                    </div>
                    <div v-else>
                        <span v-for="form in model.defaultForEventForms" class="badge badge-light">{{form}}</span>
                    </div>
                </div>

                <div class="col-12" v-if="allowEdit && hasEditRights">
                    <button type="button" class="btn btn-primary float-right"
                            @click.stop="editTariff">
                    <i class="far fa-edit mr-2"></i>
                    {{$t('buttons.edit.btnText')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { TariffEntity } from './../../models/models'
    import { Culture } from '../../models/enums'
    import tariffService from '../../services/tariff.service'

    export default {
        inject: ['$validator'],
        props: {
            id: Number,
            showContractInfo: {
                type: Boolean,
                default: true
            },
            allowEdit: {
                type: Boolean,
                default: false
            }
        },
        components: {
        },
        data() {
            return {
                model: {},
                loading: false
            }
        },
        mounted: function () {
            this.load()
        },
        computed: {
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            hasEditRights() {
                return this.$store.getters.claims.tariff.create ||
                    this.$store.getters.claims.tariff.update;
            },
        },
        methods: {
            load() {
                this.loading = true
                tariffService.loadDetails(this.id)
                    .then((response) => {
                        this.loading = false
                        this.model = new TariffEntity(response.data.model)
                    }).catch(error => {
                        this.loading = false

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    })
            },
            editTariff() {
                let routeData = this.$router.resolve({ name: 'editTariffEntity', params: { id: this.id } });
                window.open(routeData.href, '_blank');
            }
        }
    }

</script>

<style scoped>
</style>
